import { render, staticRenderFns } from "./InformacionModal.vue?vue&type=template&id=ab7c7220&scoped=true"
import script from "./InformacionModal.vue?vue&type=script&lang=js"
export * from "./InformacionModal.vue?vue&type=script&lang=js"
import style0 from "./InformacionModal.vue?vue&type=style&index=0&id=ab7c7220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7c7220",
  null
  
)

export default component.exports